// extracted by mini-css-extract-plugin
export var label = "_8i-1";
export var reminder = "_8i-0";